import { Queue } from '@cian/event-queue';

export const getEventQueue = () => {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue());
  }

  return new Queue();
};
